import { createAction, props } from '@ngrx/store';

import { ErrorDto } from '@platform/shared/error.model';

import { ContactDto } from './contacts/contacts.model';
import {
  CustomerSpaceAdminDto,
  CustomerSpaceDto,
  PostCustomerSpaceDto,
  PostCustomerSpaceUserDto,
} from './customer-space/customer-space.model';
import { NotificationDto } from './notification/notification.model';
import { TemplateActualisationDto } from './sharepoint/sharepoint.model';
import { PostUserDto, PutUserProfileDto, UserDto, UserOverviewDto, UserProfileDto } from './users/user.model';
import { MobileUploadDto } from './mobile-upload/mobile-upload.model';

export const loadCustomerSpace = createAction('[Core] Load CustomerSpace', props<{ customerSpaceId: string }>());

export const loadCustomerSpaceSucceeded = createAction('[Core] Load CustomerSpace Succeeded', props<{ customerSpace: CustomerSpaceDto }>());

export const loadCustomerSpaceFailed = createAction('[Core] Load CustomerSpace Failed', props<{ status: number; errors: ErrorDto }>());

export const loadCustomerSpaceCount = createAction('[Core] Load CustomerSpace Count');

export const loadCustomerSpaceCountSucceeded = createAction('[Core] Load CustomerSpace Count Succeeded', props<{ count: number }>());

export const loadCustomerSpaceCountFailed = createAction(
  '[Core] Load CustomerSpace Count Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadCustomerSpaces = createAction('[Core] Load CustomerSpaces');

export const loadCustomerSpacesSucceeded = createAction(
  '[Core] Load CustomerSpaces Succeeded',
  props<{ customerSpaces: CustomerSpaceDto[] }>(),
);

export const loadCustomerSpacesFailed = createAction('[Core] Load CustomerSpaces Failed', props<{ status: number; errors: ErrorDto }>());

export const resetCustomerSpaceAdmin = createAction('[Core] Reset CustomerSpace Admin');

export const loadCustomerSpaceAdmin = createAction('[Core] Load CustomerSpace Admin', props<{ customerSpaceId: string }>());

export const loadCustomerSpaceAdminSucceeded = createAction(
  '[Core] Load CustomerSpace Admin Succeeded',
  props<{ customerSpace: CustomerSpaceAdminDto }>(),
);

export const loadCustomerSpaceAdminFailed = createAction(
  '[Core] Load CustomerSpace Admin Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const createCustomerSpace = createAction('[Core] Create CustomerSpace', props<{ customerSpace: PostCustomerSpaceDto }>());

export const createCustomerSpaceSucceeded = createAction(
  '[Core] Create CustomerSpace Succeeded',
  props<{ customerSpace: CustomerSpaceAdminDto }>(),
);

export const createCustomerSpaceFailed = createAction('[Core] Create CustomerSpace Failed', props<{ status: number; errors: ErrorDto }>());

export const updateCustomerSpace = createAction(
  '[Core] Update CustomerSpace',
  props<{ id: string; customerSpace: PostCustomerSpaceDto }>(),
);

export const updateCustomerSpaceSucceeded = createAction(
  '[Core] Update CustomerSpace Succeeded',
  props<{ customerSpace: CustomerSpaceAdminDto }>(),
);

export const updateCustomerSpaceSucceeded2 = createAction(
  '[Core] Update CustomerSpace Succeeded 2',
  props<{ customerSpace: CustomerSpaceAdminDto }>(),
);

export const updateCustomerSpaceFailed = createAction('[Core] Update CustomerSpace Failed', props<{ status: number; errors: ErrorDto }>());

export const deleteCustomerSpace = createAction('[Core] Delete CustomerSpace', props<{ customerSpaceId: string }>());

export const deleteCustomerSpaceSucceeded = createAction('[Core] Delete CustomerSpace Succeeded');

export const deleteCustomerSpaceFailed = createAction('[Core] Delete CustomerSpace Failed', props<{ status: number; errors: ErrorDto }>());

export const removeCustomerSpaceUser = createAction(
  '[Core] Remove User from CustomerSpace',
  props<{ customerSpaceId: string; userId: string }>(),
);

export const removeCustomerSpaceUserSucceeded = createAction(
  '[Core] Remove User from CustomerSpace Succeeded',
  props<{ customerSpace: CustomerSpaceAdminDto }>(),
);

export const removeCustomerSpaceUserFailed = createAction(
  '[Core] Remove User from CustomerSpace Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const updateCustomerSpaceUser = createAction(
  '[Core] Update CustomerSpace User',
  props<{ customerSpaceId: string; updateUser: PostCustomerSpaceUserDto }>(),
);

export const updateCustomerSpaceUserSucceeded = createAction(
  '[Core] Update CustomerSpace User Succeeded',
  props<{ customerSpace: CustomerSpaceAdminDto }>(),
);

export const updateCustomerSpaceUserFailed = createAction(
  '[Core] Update CustomerSpace User Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadCustomerSpaceUsers = createAction('[Core] Load CustomerSpace Users', props<{ customerSpaceId: string }>());

export const loadCustomerSpaceUsersSucceeded = createAction('[Core] Load CustomerSpace Users Succeeded', props<{ users: UserDto[] }>());

export const loadCustomerSpaceUsersFailed = createAction(
  '[Core] Load CustomerSpace Users Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadUserOrganizationUnits = createAction('[Core] Load User OrganizationUnits');

export const loadUserOrganizationUnitsSucceeded = createAction(
  '[Core] Load User OrganizationUnits Succeeded',
  props<{ organizationUnits: string[] }>(),
);

export const loadUserOrganizationUnitsFailed = createAction(
  '[Core] Load User OrganizationUnits Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadActiveUsers = createAction('[Core] Load Active Users');

export const loadActiveUsersSucceeded = createAction('[Core] Load Active Users Succeeded', props<{ users: UserDto[] }>());

export const loadActiveUsersFailed = createAction('[Core] Load Active Users Failed', props<{ status: number; errors: ErrorDto }>());

export const loadUserOverview = createAction('[Core] Load User Overview');

export const loadUserOverviewSucceeded = createAction('[Core] Load User Overview Succeeded', props<{ users: UserOverviewDto[] }>());

export const loadUserOverviewFailed = createAction('[Core] Load User Overview Failed', props<{ status: number; errors: ErrorDto }>());

export const createUser = createAction(
  '[Core] Create User',
  props<{ user: PostUserDto; update?: PostCustomerSpaceUserDto; customerSpaceId?: string }>(),
);

export const createUserSucceeded = createAction('[Core] Create User Succeeded', props<{ user: UserDto }>());

export const createUserFailed = createAction('[Core] Create User Failed', props<{ status: number; errors: ErrorDto }>());

export const clearCreatedUser = createAction('[Core] Clear Created User');

export const loadUserProfile = createAction('[Core] Load User Profile', props<{ userId: string }>());

export const loadUserProfileSucceeded = createAction('[Core] Load User Profile Succeeded', props<{ userProfile: UserProfileDto }>());

export const loadUserProfileFailed = createAction('[Core] Load User Profile Failed', props<{ status: number; errors: ErrorDto }>());

export const updateUserProfile = createAction(
  '[User Settings Form] Update User Profile',
  props<{ userId: string; userProfile: PutUserProfileDto }>(),
);

export const updateUserProfileSucceeded = createAction('[Core] Update User Profile Succeeded', props<{ userProfile: UserProfileDto }>());

export const updateUserProfileFailed = createAction('[Core] Update User Profile Failed', props<{ status: number; errors: ErrorDto }>());

export const addUserDeputy = createAction('[Core] Add User Deputy', props<{ userId: string; deputyId: string }>());

export const addUserDeputySucceeded = createAction('[Core] Add User Deputy Succeeded', props<{ userProfile: UserProfileDto }>());

export const addUserDeputyFailed = createAction('[Core] Add User Deputy Failed', props<{ status: number; errors: ErrorDto }>());

export const removeUserDeputy = createAction('[Core] Remove User Deputy', props<{ userId: string; deputyId: string }>());

export const removeUserDeputySucceeded = createAction('[Core] Remove User Deputy Succeeded', props<{ userProfile: UserProfileDto }>());

export const removeUserDeputyFailed = createAction('[Core] Remove User Deputy Failed', props<{ status: number; errors: ErrorDto }>());

export const resendWelcomeMail = createAction('[Core] Resend Welcome Mail', props<{ userId: string }>());

export const resendWelcomeMailSucceeded = createAction('[Core] Resend Welcome Mail Succeeded', props<{ userProfile: UserProfileDto }>());

export const resendWelcomeMailFailed = createAction('[Core] Resend Welcome Mail Failed', props<{ status: number; errors: ErrorDto }>());

export const extractSharepointCustomerSpaceTemplate = createAction('[Core] Extract Sharepoint Customer Space Template');

export const extractSharepointCustomerSpaceTemplateSucceeded = createAction('[Core] Extract Sharepoint Customer Space Template Succeeded');

export const extractSharepointCustomerSpaceTemplateFailed = createAction(
  '[Core]  Extract Sharepoint Customer Space Template Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const extractSharepointProjectTemplate = createAction('[Core] Extract Sharepoint Project Template');

export const extractSharepointProjectTemplateSucceeded = createAction('[Core] Extract Sharepoint Project Template Succeeded');

export const extractSharepointProjectTemplateFailed = createAction(
  '[Core]  Extract Sharepoint Project Template Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const getLatestTemplateActualisations = createAction('[Core] Get Latest Template Actualisations');

export const getLatestTemplateActualisationsSucceeded = createAction(
  '[Core] Get Latest Template Actualisations Succeeded',
  props<{ templateActualisation: TemplateActualisationDto }>(),
);

export const getLatestTemplateActualisationsFailed = createAction(
  '[Core] Get Latest Template Actualisations Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const getCustomerSpaceNotifications = createAction('[Core] Get Customer Space Notifications', props<{ customerSpaceId: string }>());

export const getCustomerSpaceNotificationsSucceeded = createAction(
  '[Core] Get Customer Space Notifications Succeeded',
  props<{ notifications: NotificationDto[] }>(),
);

export const getCustomerSpaceNotificationsFailed = createAction(
  '[Core] Get Customer Space Notifications Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const markNotificationAsRead = createAction(
  '[Core] Mark Notification as Read',
  props<{ customerSpaceId: string; notificationId: string }>(),
);

export const markNotificationAsReadSucceeded = createAction(
  '[Core] Mark Notification as Read Succeeded',
  props<{ notifications: NotificationDto[] }>(),
);

export const markNotificationAsReadFailed = createAction(
  '[Core] Mark Notification as Read Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const markNotificationAsUnread = createAction(
  '[Core] Mark Notification as Unread',
  props<{ customerSpaceId: string; notificationId: string }>(),
);

export const markNotificationAsUnreadSucceeded = createAction(
  '[Core] Mark Notification as Unread Succeeded',
  props<{ notifications: NotificationDto[] }>(),
);

export const markNotificationAsUnreadFailed = createAction(
  '[Core] Mark Notification as Unread Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const markAllNotificationsAsRead = createAction('[Core] Mark all Notifications as Read', props<{ customerSpaceId: string }>());

export const markAllNotificationsAsReadSucceeded = createAction(
  '[Core] Mark all Notifications as Read Succeeded',
  props<{ notifications: NotificationDto[] }>(),
);

export const markAllNotificationsAsReadFailed = createAction(
  '[Core] Mark all Notifications as Read Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadContacts = createAction('[Core] Load Contacts', props<{ customerSpaceId: string }>());

export const loadContactsSucceeded = createAction('[Core] Load Contacts Succeeded', props<{ contacts: ContactDto[] }>());

export const loadContactsFailed = createAction('[Core] Load Contacts Falied', props<{ status: number; errors: ErrorDto }>());

export const showNotifications = createAction('[Core] Show Notifications', props<{ show: boolean }>());

export const addCustomerSpaceFavorite = createAction('[Core] Add Customer Space Favorite', props<{ customerSpaceId: string }>());

export const addCustomerSpaceFavoriteSucceeded = createAction(
  '[Core] Add Customer Space Favorite Succeeded',
  props<{ customerSpaceId: string }>(),
);

export const addCustomerSpaceFavoriteFailed = createAction(
  '[Core] Add Customer Space Favorite Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const addFavorite = createAction('[Core] Add Favorite', props<{ parentId: string }>());

export const addFavoriteSucceeded = createAction('[Core] Add Favorite Succeeded');

export const addFavoriteFailed = createAction('[Core] Add Favorite Failed', props<{ status: number; errors: ErrorDto }>());

export const deleteCustomerSpaceFavorite = createAction('[Core] Delete Customer Space Favorite', props<{ customerSpaceId: string }>());

export const deleteCustomerSpaceFavoriteSucceeded = createAction(
  '[Core] Delete Customer Space Favorite Succeeded',
  props<{ customerSpaceId: string }>(),
);

export const deleteCustomerSpaceFavoriteFailed = createAction(
  '[Core] Delete Customer Space Favorite Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const deleteFavorite = createAction('[Core] Delete Favorite', props<{ parentId: string }>());

export const deleteFavoriteSucceeded = createAction('[Core] Delete Favorite Succeeded');

export const deleteFavoriteFailed = createAction('[Core] Delete Favorite Failed', props<{ status: number; errors: ErrorDto }>());

export const loadCurrentUserRepresenteeIds = createAction('[Core] Load Current User Representee Ids');

export const loadCurrentUserRepresenteeIdsSucceeded = createAction(
  '[Core] Load Current User Succeeded Representee Ids',
  props<{ representeeIds: string[] }>(),
);

export const loadCurrentUserRepresenteeIdsFailed = createAction(
  '[Core] Load Current User Failed Representee Ids',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadMobileUpload = createAction('[Core] Load Mobile Upload', props<{ customerSpaceId: string; mobileUploadId: string }>());

export const loadMobileUploadSucceeded = createAction('[Core] Load Mobile Upload Succeeded', props<{ mobileUploadDto: MobileUploadDto }>());

export const loadMobileUploadFailed = createAction('[Core] Load Mobile Upload Failed', props<{ status: number; errors: ErrorDto }>());

export const uploadMobileFiles = createAction(
  '[Core] Upload Mobile File',
  props<{ customerSpaceId: string; mobileUploadId: string; fileList: FileList | File[] }>(),
);

export const uploadMobileFilesSucceeded = createAction('[Core] Upload Mobile File Succeeded');

export const uploadMobileFilesFailed = createAction('[Core] Upload Mobile File Failed', props<{ status: number; errors: ErrorDto }>());

export const uploadBatchCreationFile = createAction('[Core] Upload Batch Creation File', props<{ files: FileList | File[] }>());

export const uploadBatchCreationFileSucceeded = createAction('[Core] Upload Batch Creation File Succeeded');

export const uploadBatchCreationFileFailed = createAction(
  '[Core] Upload Batch Creation File Failed',
  props<{ status: number; errors: ErrorDto }>(),
);
